import type { Theme } from '@emotion/react'
import { css } from '@emotion/react'

import { createAnimation, duration, easing, zIndex } from '@twisto/styles'

const animations = {
  show: createAnimation('showLoader', {
    '100%': {
      opacity: 1,
    },
  }),
}

export const root = (theme: Theme) => css`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  background: ${theme.palette.background.main}cc; //adding opacity to background
  cursor: wait;

  display: flex;
  align-items: center;
  justify-content: center;

  opacity: 0;
  animation: ${animations.show.name} ${duration.shorter}ms
    ${easing.easeOut} forwards;

  ${animations.show.definition}
`

export const layers = {
  default: css`
    z-index: ${zIndex.loader};
  `,
  modal: css`
    z-index: ${zIndex.modalLoader};
  `,
}

export const variants = (theme: Theme) => ({
  default: css`
    padding: ${theme.spacing[8]};
  `,
  compact: css`
    padding-top: ${theme.spacing[24]};
    padding-bottom: ${theme.spacing[24]};
    align-items: flex-start;
  `,
})

export const grayBackground = (theme: Theme) => css`
  background: ${theme.palette.background.accent};
`
